import { ExamDatesForLocationsCentreContext } from './centreContext/ExamDatesForLocationsCentreContext';
import { useNavigationContext } from 'hooks';
import { ExamDatesForLocationsDistrictContext } from './districtContext/ExamDatesForLocationsDistrictContext';

export const ExamDatesForLocations = () => {
  const { centreId, locationId } = useNavigationContext();

  return (
    <>
      {centreId && locationId === undefined && <ExamDatesForLocationsCentreContext />}
      {centreId && locationId && <ExamDatesForLocationsDistrictContext />}
    </>
  );
};
